import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { ProductModifierGroup } from "~/providers/product-provider";

interface ModifierGroupStoreState {
  modifierGroupFormOpen: boolean;
  currentModifierGroup?: ProductModifierGroup;
  setCurrentModifierGroup: (currentGroup?: ProductModifierGroup) => void;
  setModifierGroupFormOpen: (open: boolean) => void;
}

export const useModifierGroupStore = create<ModifierGroupStoreState>()(
  devtools((set) => ({
    modifierGroupFormOpen: false,
    setCurrentModifierGroup(currentGroup) {
      set(() => ({ currentModifierGroup: currentGroup }));
    },
    setModifierGroupFormOpen(open) {
      set(() => ({ modifierGroupFormOpen: open }));
    },
  })),
);
